module.exports = __webpack_public_path__ + "header-profile-skin-3.bf471ec3d4085883e061.png";


//////////////////
// WEBPACK FOOTER
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/assets/styles/patterns/header-profile-skin-3.png
// module id = ../../../../../src/assets/styles/patterns/header-profile-skin-3.png
// module chunks = styles